import { requestGet } from '../../utils/request';

const FIELD_URL = '/api/fields';

export function requestFieldDetails(fieldId) {
  return requestGet(`${FIELD_URL}/${fieldId}`, {
    mockFile: 'field/default',
  });
}
